import { render, staticRenderFns } from "./configuration-automatic-billable-concept-rules-grid.vue?vue&type=template&id=85fca532&"
import script from "./configuration-automatic-billable-concept-rules-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-automatic-billable-concept-rules-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports